import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { BookOpenIcon, CalendarIcon, UtensilsIcon, ActivityIcon, MoonIcon } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpenIcon className="w-8 h-8 text-brand-goldDark" data-id="element-155" />,
    title: 'El Manual Salud Dorada (PDF)',
    desc: 'La guía paso a paso para desinflamar tu cuerpo.'
  }, {
    icon: <CalendarIcon className="w-8 h-8 text-brand-goldDark" data-id="element-156" />,
    title: 'El Plan de 14 Días',
    desc: 'Menús diarios diseñados para eliminar la rigidez matutina.'
  }, {
    icon: <UtensilsIcon className="w-8 h-8 text-brand-goldDark" data-id="element-157" />,
    title: 'Lista de "Super-Sabores"',
    desc: 'Los 7 ingredientes latinos que funcionan como ibuprofeno natural.'
  }, {
    icon: <ActivityIcon className="w-8 h-8 text-brand-goldDark" data-id="element-158" />,
    title: 'Guía de Micro-Movilidad',
    desc: 'Ejercicios de 5 minutos que puedes hacer sentada en tu sala.'
  }, {
    icon: <MoonIcon className="w-8 h-8 text-brand-goldDark" data-id="element-159" />,
    title: 'Ritual del Amanecer Ligero',
    desc: 'El secreto nocturno para levantarte con agilidad.'
  }];
  return <section className="py-16 px-6 bg-brand-cream" data-id="element-160">
      <div className="max-w-4xl mx-auto" data-id="element-161">
        <FadeIn data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-163">
            Lo que recibirás hoy:
          </h2>
        </FadeIn>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-164">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={index === items.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''} data-id="element-165">
              <div className="bg-white p-6 rounded-2xl shadow-soft flex items-start h-full border border-brand-creamDark hover:border-brand-gold/50 transition-colors" data-id="element-166">
                <div className="bg-brand-cream p-3 rounded-xl mr-5 shrink-0" data-id="element-167">
                  {item.icon}
                </div>
                <div data-id="element-168">
                  <h3 className="font-bold text-xl mb-2" data-id="element-169">{item.title}</h3>
                  <p className="text-brand-brown/80" data-id="element-170">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} className="mt-16 text-center" data-id="element-171">
          <CTAButton data-id="element-172">OBTÉN TODO ESTO POR SOLO $6.39</CTAButton>
        </FadeIn>
      </div>
    </section>;
}